<template>
    <div :class="swiperClass" class="vacation-type-swiper">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <slot></slot>
            </div>
        </div>

        <div class="swiper-button-next">
            <i class="icon icon-next"></i>
        </div>
        <div class="swiper-button-prev">
            <i class="icon icon-prev"></i>
        </div>

        <div class="swiper-pagination"></div>
    </div>
</template>

<script>
    export default {
        props: ['swiperClass']
    }
</script>